<template>
	<div class="page">
		<box>
			<el-form label-position="right" label-width="90px" class="EL-Form">
				<el-col :lg="5" :xl="5">
					<el-form-item label="通道编号" class="EL-Form-Item">
						<el-select
							multiple
							collapse-tags
							v-model="whCodeList"
							filterable
							placeholder="请选择"
							clearable="clearable"
						>
							<el-option
								v-for="item in warehouseList"
								:key="item.whId"
								:value="item.whCode"
								:label="item.whCode + '-' + item.whName"
								>{{ item.whCode }}-{{ item.whName }}</el-option
							>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="物料编号" class="EL-Form-Item">
						<el-select v-model="mainSearch.matCode" filterable clearable placeholder="请选择" multiple collapse-tags>
							<el-option
							v-for="item in materialList"
							:key="item.mtCode"
							:label="item.mtCode"
							:value="item.mtCode">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="物料描述" class="EL-Form-Item">
						<el-input v-model="mainSearch.matName" placeholder="请输入"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
					<el-form-item label="物料批次" class="EL-Form-Item">
						<el-input v-model="mainSearch.batchNo" placeholder="请输入"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="4" :xl="4">
					<el-form-item class="btn-edit-delete EL-Form-Item">
						<el-button class="btn-t-edit" @click="saveSearch()">查询</el-button>
						<el-button class="btn-t-delete" @click="reset">重置</el-button>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
					<el-form-item label="物料批次" class="EL-Form-Item">
						<el-input v-model="mainSearch.batchNo" placeholder="请输入"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="物料状态" class="EL-Form-Item">
						<el-select v-model="mainSearch.wiStatus" clearable="clearable">
							<el-option key="0" value="" label="全部"></el-option>
							<el-option label="正常" value="NORMAL"> </el-option>
							<!-- <el-option label="过期" value="OVERTIME"> </el-option>
                            <el-option label="作废" value="DELETE"> </el-option> -->
							<el-option label="冻结" value="AGFREEZE"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<!-- <el-form-item label="库区" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="chooseDictDataList" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in dictDataList" :key="item.ddId" :label="item.ddName" :value="item.ddCode"></el-option>
                        </el-select>
                    </el-form-item> -->
					<el-form-item label="仓库库存" class="EL-Form-Item">
						<el-select
							collapse-tags
							v-model="mainSearch.whType"
							placeholder="请选择"
							clearable="clearable"
						>
							<el-option key="" label="全部" value=""></el-option>
							<el-option key="1" label="是" value="1"></el-option>
							<el-option key="2" label="否" value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="库位" class="EL-Form-Item">
						<el-select v-model="mainSearch.lcCode" placeholder="请选择" filterable clearable="clearable">
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="库区" class="EL-Form-Item">
						<el-input
							v-model="mainSearch.waCode"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>

				<!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="第几层" class="EL-Form-Item">
                        <el-input v-model="mainSearch.height" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col> -->
				<el-col :lg="5" :xl="5">
					<el-form-item label="包装箱号" class="EL-Form-Item">
						<el-input v-model="mainSearch.boxBarcode" placeholder="请输入"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="订单编号" class="EL-Form-Item">
						<el-input
							v-model="mainSearch.orderCode"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="规值" class="EL-Form-Item">
						<el-input
							v-model="mainSearch.matSpecs"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="开始日期" class="EL-Form-Item">
						<el-date-picker
							v-model="mainSearch.date[0]"
							value-format="yyyy-MM-dd HH:mm"
							type="date"
							placeholder="开始日期"
							:picker-options="pickerOptions0"
						></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="结束日期" class="EL-Form-Item">
						<el-date-picker
							v-model="mainSearch.date[1]"
							value-format="yyyy-MM-dd HH:mm"
							type="date"
							placeholder="结束日期"
							:picker-options="pickerOptions"
						></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="收货人" class="EL-Form-Item">
						<el-input
							v-model="mainSearch.consignee"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="原箱号" class="EL-Form-Item">
						<el-input
							v-model="mainSearch.oldBoxBarcode"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="质检状态" class="EL-Form-Item">
						<el-select v-model="mainSearch.checkResult" clearable="clearable">
							<el-option key="0" value="" label="全部"></el-option>
							<el-option label="待检" value="10"> </el-option>
							<el-option label="合格" value="20"> </el-option>
							<el-option label="不合格" value="30"> </el-option>
							<el-option label="退货" value="40"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="仓库类型" class="EL-Form-Item">
						<el-select v-model="mainSearch.saleFlag" clearable="clearable">
							<el-option key="" value="" label="全部"></el-option>
							<el-option label="非寄售仓" value="0"> </el-option>
							<el-option label="寄售仓" value="1"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="通道状态" class="EL-Form-Item">
						<el-select v-model="mainSearch.receiptResult" clearable="clearable">
							<el-option key="0" value="" label="全部"></el-option>
							<el-option label="待接收" value="01"> </el-option>
							<el-option label="确认接收" value="10"> </el-option>
							<el-option label="拒绝接收" value="20"> </el-option>
							<el-option label="退货" value="30"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :lg="5" :xl="5">
					<el-form-item label="供应商" class="EL-Form-Item">
						<el-select v-model="mainSearch.verdorCode" placeholder="请选择" filterable clearable="clearable">
                            <el-option v-for="(item, index) in vendorList" :key="index" :label="item.svCode + ' - ' + item.vendorName" :value="item.svCode">
                            </el-option>
                        </el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="物料类型" class="EL-Form-Item">
						<el-select v-model="mainSearch.mtType" placeholder="请选择" filterable clearable="clearable"  multiple collapse-tags>
                            <el-option v-for="(item, index) in mtTypeList" :key="index" :label="item.ddCode+' - '+item.ddName" :value="item.ddCode">
                            </el-option>
                        </el-select>
					</el-form-item>
				</el-col>
				<!--<el-col :lg="5" :xl="5">
					<el-form-item label="SBN" class="EL-Form-Item">
						<el-input
							v-model="mainSearch.SBN"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>-->
			</el-form>
		</box>
		<box fill>
			<plabel text="库存列表">
				<el-button @click="importInShow = true" class="btn-t-edit">导入库存</el-button>
				<el-button v-authority="'BACK_MENU1_M1_B1'" @click="upWhInventory()" class="btn-t-edit"
					>库存编辑</el-button
				>
				<el-button v-authority="'BACK_MENU1_M1_B2'" @click="pdfPrint()" class="btn-t-edit"
					>单据打印</el-button
				>
				<el-button v-authority="'BACK_MENU1_M1_B3'" @click="rePrintBarcodeNew('print')" class="btn-t-edit"
					>标签打印</el-button
				>
				<el-button v-authority="'BACK_MENU1_M1_B3'" @click="rePrintBarcodeNew('priview')" class="btn-t-edit">标签预览</el-button>
				<el-button
					v-authority="'BACK_MENU1_M1_B4'"
					:loading="downloadLoading"
					class="btn-t-edit"
					type="primary"
					@click="downLoadFile()"
					>导出EXCEL</el-button
				>
			</plabel>
			<h-table
				:summaryMethod="getSummaries"
				show-summary
				:headerCellStyle="mainData.headerCellStyle"
				style="flex: 1"
				@pageChange="getTableData()"
				:data="mainData.data"
				pagination
				:nowPage.sync="mainData.nowPage"
				:pageSize.sync="mainData.pageSize"
				:total.sync="mainData.total"
				ref="hTable"
				@selectionChange="selectAllPrintLists"
			>
				<el-table-column type="selection" align="center"></el-table-column>
				<el-table-column label="订单编号" align="center" prop="orderCode"></el-table-column>
				<el-table-column label="物料编号" align="center" prop="matCode" min-width="100"></el-table-column>
				<el-table-column label="物料描述" align="center" prop="matName" min-width="200"></el-table-column>
				<el-table-column label="规值" prop="matSpecs" align="center"></el-table-column>
				<el-table-column label="可用数量" align="center" prop="matAvaliableQuan">
					<template slot-scope="scope">
						{{ scope.row.matQuan - scope.row.matDistrQuan }}
					</template>
				</el-table-column>
				<el-table-column label="物料总数量" align="center" prop="matQuan"></el-table-column>
				<el-table-column label="物料状态" align="center" width="80px">
					<template slot-scope="scope">
						<span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
						<!-- <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span> -->
						<span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
					</template>
				</el-table-column>
				<el-table-column label="质检状态" align="center" width="80px">
					<template slot-scope="scope">
						<span v-if="scope.row.checkResult == '10'">待检</span>
						<span v-if="scope.row.checkResult == '20'">合格</span>
						<span v-if="scope.row.checkResult == '30'">不合格</span>
						<span v-if="scope.row.checkResult == '40'">退货</span>
					</template>
				</el-table-column>
				<el-table-column label="物料批次" align="center" prop="batchNo"></el-table-column>
				<el-table-column label="包装箱号" align="center" prop="boxBarcode" min-width="100"></el-table-column>
				<el-table-column label="库位" align="center" prop="lcCode"></el-table-column>
				<el-table-column label="库区" align="center" prop="waCode"></el-table-column>
				<el-table-column label="仓库类型" align="center">
					<template slot-scope="scope">
						{{ scope.row.saleFlag ? "寄售仓" : "非寄售仓" }}
					</template>
				</el-table-column>
				<el-table-column
					label="入库时间"
					align="center"
					prop="matCreateTime"
					:formatter="dateFormat"
					width="100px"
					sortable
				></el-table-column>
				<el-table-column label="生产时间" align="center" prop="matProduceTime" min-width="130"></el-table-column>
				<!--<el-table-column label="SBN" align="center" prop="batchSbn"></el-table-column>-->
				<el-table-column label="通道编号" align="center" prop="whCode"></el-table-column>
				<el-table-column label="已分配数量" align="center" prop="matDistrQuan"></el-table-column>
				<el-table-column label="通道状态" align="center" width="80px">
					<template slot-scope="scope">
						<span v-if="scope.row.receiptResult == '01'">待接收</span>
						<span v-if="scope.row.receiptResult == '10'">确认接收</span>
						<span v-if="scope.row.receiptResult == '20'">拒绝接收</span>
						<span v-if="scope.row.receiptResult == '30'">退货</span>
					</template>
				</el-table-column>
				<el-table-column label="供应商" align="center" prop="verdorCode">
				</el-table-column>
				<el-table-column label="供应商名称" align="center" min-width="100px" prop="svName">
				</el-table-column>
				<el-table-column label="收货人" align="center" prop="consignee"></el-table-column>
				<el-table-column label="物料类型" align="center" prop="mtType"></el-table-column>
			<!--	<el-table-column label="热处理批号" align="center" prop="heatNumber"></el-table-column>
				<el-table-column label="钢材炉号" align="center" prop="heatNo"></el-table-column>
				<el-table-column label="材料牌号" align="center" prop="materialGrade"></el-table-column>-->
				<el-table-column label="原箱号" align="center" min-width="110px">
					<template slot-scope="scope">
						{{ scope.row.oldBoxBarcode != null ? scope.row.oldBoxBarcode : scope.row.boxBarcode }}
					</template>
				</el-table-column>
				<el-table-column label="备注" align="center" prop="remark"></el-table-column>
			</h-table>
		</box>

		<!-- 打印 -->
		<el-dialog
			title="打印"
			:visible.sync="printShow"
			width="1000px"
			:close-on-click-modal="false"
			style="height:100%"
		>
			<div class="divdiv">
				<v-print :doPrint.sync="print">
					<div id="demo" class="demo11">
						<div style="margin-top:20px;margin-left:800px">
							<el-button
								class="btn-t-info"
								type="info"
								@click="(printShow = false), ((printList = []), (boxCount = 0), (sumCount = 0))"
								>取消</el-button
							>
							<el-button
								class="btn-t-edit"
								@click="((print = true), (printShow = false)), ((boxCount = 0), (sumCount = 0))"
								>打印</el-button
							>
						</div>
						<div class="div1">
							打印时间：{{ printTime }}&nbsp;&nbsp;&nbsp;&nbsp;箱数：{{
								boxCount
							}}&nbsp;&nbsp;&nbsp;&nbsp;总数量：{{ sumCount }}
						</div>
						<div class="div">
							<table border="1" cellpadding="0" cellspacing="0">
								<thead style="display:table-header-group;font-weight:bold">
									<tr>
										<th>通道编号</th>
										<th>物料编号</th>
										<th>物料描述</th>
										<th>物料数量</th>
										<th>物料批次</th>
										<th>库位</th>
										<th>包装箱号</th>
										<th>规值</th>
										<th>物料状态</th>
										<th>入库时间</th>
										<th>备注</th>
									</tr>
								</thead>
								<tr v-for="(item, index) in printData" :key="index">
									<td>{{ item.whCode }}</td>
									<td>{{ item.matCode }}</td>
									<td>{{ item.matName }}</td>
									<td>{{ item.matQuan }}</td>
									<td>{{ item.batchNo }}</td>
									<td>{{ item.lcCode }}</td>
									<td>{{ item.boxBarcode }}</td>
									<td>{{ item.matSpecs }}</td>
									<td>
										<span v-if="item.wiStatus == 'NORMAL'">正常</span>
										<!-- <span v-if="item.wiStatus == 'OVERTIME'">过期</span>
                                        <span v-if="item.wiStatus == 'DELETE'">作废</span> -->
										<span v-if="item.wiStatus == 'AGFREEZE'">冻结</span>
									</td>
									<td>{{ item.matCreateTime }}</td>
									<td>{{ item.remark }}</td>
								</tr>
							</table>
						</div>
					</div>
				</v-print>
			</div>
			<div style="margin-top: 50px;height:70px">
				<!-- <el-button class="btn-t-edit" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button> -->
			</div>
		</el-dialog>

		<!-- 库存编辑 -->
		<el-dialog
			title="库存编辑"
			:visible.sync="upDataShow"
			class="infoDialog"
			:close-on-click-modal="false"
			:show-close="false"
		>
			<el-form
				label-position="right"
				label-width="90px"
				class="EL-Form"
				:rules="ruleUp"
				:model="upDataObj"
				ref="upDataObj"
			>
				<el-col :lg="8" :xl="8">
					<el-form-item label="通道编号" class="EL-Form-Item" prop="whCode">
						<el-input
							v-model="upDataObj.whCode"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="库位" class="EL-Form-Item" prop="lcCode">
						<el-input
							v-model="upDataObj.lcCode"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="物料编号" class="EL-Form-Item" prop="matCode">
						<el-input
							v-model="upDataObj.matCode"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="物料批次" class="EL-Form-Item" prop="batchNo">
						<el-input
							v-model="upDataObj.batchNo"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="物料总数量" class="EL-Form-Item" prop="matQuan">
						<el-input-number
							v-model="upDataObj.matQuan"
							:min="0"
							style="width:100%;"
						></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="入库时间" class="EL-Form-Item">
						<el-input
							v-model="upDataObj.matCreateTime"
							placeholder="请输入"
							clearable="clearable"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="物料描述" class="EL-Form-Item">
						<el-input v-model="upDataObj.matName" readonly></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="已分配数量" class="EL-Form-Item">
						<el-input v-model="upDataObj.matDistrQuan"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="箱号" class="EL-Form-Item">
						<el-input v-model="upDataObj.boxBarcode" readonly></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="订单号" class="EL-Form-Item">
						<el-input v-model="upDataObj.orderCode" readonly></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="规值" class="EL-Form-Item">
						<el-input v-model="upDataObj.matSpecs"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="物料状态" class="EL-Form-Item">
						<el-select v-model="upDataObj.wiStatus">
							<el-option key="0" value="" label="全部"></el-option>
							<el-option label="正常" value="NORMAL"> </el-option>
							<el-option label="过期" value="OVERTIME"> </el-option>
							<el-option label="作废" value="DELETE"> </el-option>
							<el-option label="人工冻结" value="AGFREEZE"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="收货人" class="EL-Form-Item">
						<el-input v-model="upDataObj.consignee" readonly></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="热处理批号" class="EL-Form-Item">
						<el-input v-model="upDataObj.heatNumber"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="钢材炉号" class="EL-Form-Item">
						<el-input v-model="upDataObj.heatNo"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="仓库类型" class="EL-Form-Item">
						<el-select v-model="upDataObj.saleFlag">
							<el-option label="寄售仓" :value="true"> </el-option>
							<el-option label="非寄售仓" :value="false"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="供应商" class="EL-Form-Item">
						<el-input v-model="upDataObj.verdorCode"></el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="8" :xl="8">
					<el-form-item label="SBN" class="EL-Form-Item">
						<el-input v-model="upDataObj.batchSbn"></el-input>
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="upDataShow = false" type="info">取 消</el-button>
				<el-button @click="updateWhInventory()" type="danger">编辑</el-button>
			</div>
		</el-dialog>
		<el-dialog
			title="导入"
			:visible.sync="importInShow"
			class="fromDialog"
			:close-on-click-modal="false"
			:show-close="false"
			@click.stop
			:style="$popups.popups(0.8, 0.9)"
		>
			<div class="uploader-div">
				<el-upload
					:action="action"
					:file-list="fileList"
					:limit="1"
					multiple
					:accept="accept"
					:before-upload="handleBeforeUpload"
					:on-error="handleUploadError"
					:on-exceed="handleExceed"
					:on-success="handleUploadSuccess"
					:on-change="handChange"
					:http-request="httpRequest"
					:show-file-list="true"
					:auto-upload="false"
					class="upload-file-uploader"
					ref="upload"
				>
					<!-- 上传按钮 -->
					<el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
					<el-button
						style="margin-left: 10px;"
						:disabled="fileList.length < 1"
						size="small"
						type="success"
						@click="submitUpload"
						>上传到服务器</el-button
					>
					<!-- <el-button  @click="rePrintBarcode()" class="btn-t-edit">标签打印</el-button> -->
				</el-upload>
			</div>
			<h-table
				:headerCellStyle="importData.headerCellStyle"
				:style="$popups.harvestRecordStyle(0.46)"
				:data="importData.data"
				class="harvestRecord"
			>
				<el-table-column type="selection" align="center"></el-table-column>
				<!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
				<el-table-column label="序号" prop="number" align="center"> </el-table-column>
				<el-table-column label="供应商" prop="verdorCode" align="center" width="100px"></el-table-column>
				<el-table-column label="包装箱号" prop="boxBarcode" align="center" width="100px"></el-table-column>
				<el-table-column label="订单号" prop="orderCode" align="center"> </el-table-column>
				<el-table-column label="通道编号" prop="whCode" align="center"> </el-table-column>
				<!--<el-table-column label="物料编号" prop="matCode" align="center">
          </el-table-column>-->
				<el-table-column label="物料型号" prop="matCode" align="center"> </el-table-column>
				<el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
				<el-table-column label="数量" prop="matQuan" align="center"> </el-table-column>

				<el-table-column label="批次号" prop="batchNo" align="center"> </el-table-column>
				<el-table-column label="收货日期" prop="matCreateTime" align="center"> </el-table-column>
				<el-table-column label="库位" prop="lcCode" align="center"> </el-table-column>
				<el-table-column label="是否寄售" prop="saleFlag" align="center"> </el-table-column>
			</h-table>
			<div slot="footer" class="dialog-footer footer-bottom">
				<el-button @click="closeExportModel" type="info" class="btn-t-info">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import vPrint from "syl-vue-printer";
import moment from "moment";
import { getLodop } from "../../libs/LodopFuncs.js";
import { printParamsFormat, printBoxBarcode } from '@/libs/printBoxBarcode'
export default {
	name: "WhInventory",
	components: {
		vPrint,
	},
	data() {
		return {
			accept: "",
			fileList: [],
			action: "action",
			// 大小限制(MB)
			fileSize: 20,
			// 文件类型
			fileType: ".xlsx",
			// 是否显示提示
			isShowTip: {
				type: Boolean,
				default: true,
			},
			importData: {
				data: [],
				pageNum: 1,
				pageSize: 500000,
				total: 0,
				printTwo: false,
				headerCellStyle: () => {
					return "background-color: #1f6cec";
				},
			},
			printData: [], //打印数据
			print: false,
			printShow: false,
			printObj: {
				id: "demo",
				popTitle: "",
			},
			printTime: moment(new Date()).format("yyyy-MM-DD"),
			importInShow: false,
			uploaderData: {
				fileList: [],
			},

			warehouseList: [],
			mainData: {
				data: [],
				nowPage: 1,
				pageSize: 50,
				total: 0,
				headerCellStyle: () => {
					return "background-color: #1f6cec";
				},
			},
			// 筛选条件
			mainSearch: {
				fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
				whCode: "", //	通道编号
				lcCode: "", //	库位编号
				lcType: "",
				matCode: [], //	物料编号
				matName: "", //	物料描述
				batchNo: "", //	批次号
				wiStatus: "", //	库存状态 normal
				boxBarcode: "", //	箱号
				orderCode: "", //  订单编号
				matSpecs: "", //  规值
				date: [],
				height: "", //第几层
				consignee: "",
				oldBoxBarcode: "",
				checkResult: "", //质检状态
				saleFlag: "", //是否寄售
				whType: "", //仓库类型
				receiptResult: "",
				verdorCode: "",
				mtType: [],
				SBN: "",
				waCode: "",
			},
			//全选
			checkList: [],
			selectAllPrintList: [],
			//下载中
			downloadLoading: false,
			//库区
			dictDataList: [],
			//选中的库区
			chooseDictDataList: [],
			//选中的通道
			whCodeList: [],
			// 输入框延时加载
			isSetTimeout: null,
			//箱数
			boxCount: 0,
			//总数量
			sumCount: 0,
			//库存编辑
			upDataShow: false,
			upDataObj: {},

			logContent: "", //操作日志-内容
			logRemarks: "", //操作日志-备注
			//校验
			ruleUp: {
				whCode: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				lcCode: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				matCode: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				batchNo: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				matQuan: [
					{
						required: true,
						message: "请输入",
						trigger: "change",
					},
				],
				matCreateTime: [
					{
						required: true,
						message: "请选择",
						trigger: "change",
					},
				],
			},
			materialList: [],
			lcCodeList: [],
			vendorList: [],
			mtTypeList: [],
		};
	},
	watch: {
		mainSearch: {
			handler(newVal) {
				clearTimeout(this.isSetTimeout);
				this.isSetTimeout = setTimeout(() => {
					this.mainData.nowPage = 1;
					this.getTableData(newVal);
				}, 1000);
			},
			deep: true,
		},
		chooseDictDataList: {
			handler(newVal) {
				clearTimeout(this.isSetTimeout);
				this.isSetTimeout = setTimeout(() => {
					this.getTableData(newVal);
				}, 1000);
			},
			deep: true,
		},
		whCodeList: {
			handler(newVal) {
				clearTimeout(this.isSetTimeout);
				this.isSetTimeout = setTimeout(() => {
					this.getTableData(newVal);
				}, 1000);
			},
			deep: true,
		},
	},

	computed: {
		pickerOptions() {
			let _this = this;
			return {
				disabledDate(time) {
					if (_this.mainSearch.date[0]) {
						return time.getTime() < new Date(_this.mainSearch.date[0]);
					}
				},
			};
		},
		pickerOptions0() {
			let _this = this;
			return {
				disabledDate(time) {
					if (_this.mainSearch.date[1]) {
						return time.getTime() > new Date(_this.mainSearch.date[1]);
					}
				},
			};
		},
	},
	// 数据更新后重刷表格
	updated() {
		this.$nextTick(() => {
			this.$refs.hTable.$refs.table.doLayout();
		});
	},
	activated() {
		this.getWarehouse();
		this.getDictData();
		this.getTableData();
		this.getMaterialList();
		this.getLcCodeList();
		this.getVerdorList();
		this.getMtTypeList();
	},
	methods: {
		httpRequest(param) {
			var formData = new FormData();
			formData.append("file", param.file);
			this.$http
				.request({
					url: "/api/order/importExcel",
					method: "POST",
					headers: {
						"Content-Type": "multipart/form-data",
						"X-Auth-Token": localStorage.getItem("token"),
					},
					showLoading: true,
					data: formData,
				})
				.then((res) => {
					if (res.status === 100) {
						this.importData.data = res.data.list || [];
						this.$notify({
							message: "上传成功!",
							type: "success",
						});
					} else {
						this.$notify({
							message: res.message,
							type: "danger",
						});
					}
				});
		},
		// 上传前校检格式和大小
		handleBeforeUpload(file) {
			// 校检文件类型
			if (this.fileType) {
				let fileExtension = "";
				if (file.name.lastIndexOf(".") > -1) {
					fileExtension = file.name.slice(file.name.lastIndexOf("."));
				}
				const isTypeOk = this.fileType.indexOf(fileExtension) != -1 ? true : false;

				if (!isTypeOk) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType}格式文件!`);
					return false;
				}
			}
			// 校检文件大小
			if (this.fileSize) {
				const isLt = file.size / 1024 / 1024 < this.fileSize;
				if (!isLt) {
					this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
					return false;
				}
			}
			return true;
		},
		// 获取文件名称
		getFileName(name) {
			if (name.lastIndexOf("/") > -1) {
				return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
			} else {
				return "";
			}
		},
		/** 手动提交上传 */
		submitUpload() {
			if (this.fileList.length <= 0) {
				return false;
			}
			this.$refs.upload.submit();
		},
		/** 文件状态改变时调用 */
		handChange(file, fileList) {
			this.fileList = fileList;
		},
		// 删除文件
		handleDelete(index) {
			this.fileList.splice(index, 1);
		},
		// 文件个数超出
		handleExceed() {
			this.$message.error(`只允许上传1个文件`);
		},
		// 上传失败
		handleUploadError(err) {
			this.$message.error("上传失败, 请重试");
		},

		// 上传成功回调

		handleUploadSuccess(res, file) {
			this.$message.success("上传成功");
			this.getTableData();
			this.cancel();
		},
		// 节流搜索
		saveSearch() {
			if (window.lazy) window.clearTimeout(window.lazy);
			window.lazy = window.setTimeout(() => {
				this.getTableData();
			}, 1000);
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = "合计";
					return;
				}
				const values = data.map((item) => Number(item[column.property]));
				if (
					!values.every((value) => isNaN(value)) &&
					(column.property == "matQuan" ||
						column.property == "matDistrQuan" ||
						column.property == "matAvaliableQuan")
				) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
					sums[index];
				}
			});

			return sums;
		},
		/**
		 *
		 */
		getTableData() {
			clearTimeout(this.isSetTimeout);
			var mainSearchLcType = "";
			var whCode = "";
			this.chooseDictDataList.forEach((item) => {
				mainSearchLcType += item + ",";
			});
			this.whCodeList.forEach((item) => {
				whCode += item + ",";
			});
			this.$http
				.request({
					url: "/api/order/getStockList",
					method: "GET",
					params: {
						pageNum: this.mainData.nowPage, //	页号
						pageSize: this.mainData.pageSize, //	页大小
						fcCode: this.mainSearch.fcCode || null, //	工厂编号
						whCode: whCode || null, //	通道编号
						lcCode: this.mainSearch.lcCode || null,
						//lcType: this.mainSearch.lcType || null,
						lcType: mainSearchLcType || null,
						matCode: this.mainSearch.matCode.join(',') || null, //	物料编号
						matName: this.mainSearch.matName || null, //	物料描述
						batchNo: this.mainSearch.batchNo || null, //	批次号
						wiStatus: this.mainSearch.wiStatus || null, //	库存状态
						boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
						opCode: this.mainSearch.orderCode || null, //  订单编号
						matSpecs: this.mainSearch.matSpecs || null, //  规值
						beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
						endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
						height: this.mainSearch.height || null,
						consignee: this.mainSearch.consignee || null,
						oldBoxBarcode: this.mainSearch.oldBoxBarcode || null,
						checkResult: this.mainSearch.checkResult || null,
						commonFlag: true, //查询公共库存的库存，不分工厂
						saleFlag: this.mainSearch.saleFlag,
						whType: this.mainSearch.whType,
						receiptResult: this.mainSearch.receiptResult,
						verdorCode: this.mainSearch.verdorCode,
						mtType: this.mainSearch.mtType.join(',') || null,
						SBN: this.mainSearch.SBN,
						waCode: this.mainSearch.waCode,
					},
				})
				.then((res) => {
					if (res.status == 100) {
						this.mainData.data = res.data.list;
						this.mainData.total = res.data.total;
					} else {
						this.$message.error("错误");
					}
				});
		},

		//获取库区
		getDictData() {
			this.$http
				.request({
					url: "/api/dictData/getDictData",
					method: "GET",
					showLoading: true,
					params: {
						ddCode: "LATYPE",
					},
				})
				.then((resp) => {
					if (resp.status == 100) {
						this.dictDataList = resp.data.list || [];
					}
				})
				.catch((error) => {});
		},

		pdfPrint() {
			if (this.selectAllPrintList.length == 0) {
				this.$message({
					message: "请选择库存记录！",
					type: "warning",
				});
				return;
			}
			this.selectAllPrintList.forEach((item) => {
				this.boxCount += 1;
				this.sumCount += item.matQuan;
			});
			this.printShow = true;
			this.printData = this.selectAllPrintList;
		},

		/**
		 * 全选
		 */
		selectAllPrintLists(val) {
			this.selectAllPrintList = val;
		},

		//禁选
		checkboxSelect(row, rowIndex) {
			if (row.wiStatus == "NORMAL") {
				return true; // 不禁用
			} else {
				return false; // 禁用
			}
		},

		/**
		 * 重置
		 */
		reset() {
			this.mainSearch = {
				fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
				whCode: "", //	通道编号
				lcCode: "", //	库位编号
				lcType: "",
				matCode: [], //	物料编号
				matName: "", //	物料描述
				batchNo: "", //	批次号
				wiStatus: "", //	库存状态 normal
				boxBarcode: "", //	箱号
				orderCode: "", //  订单编号
				matSpecs: "", //  规值
				date: [],
				height: "", //第几层
				consignee: "",
				oldBoxBarcode: "",
				checkResult: "",
				mtType: [],
			};
			this.chooseDictDataList = []; //选中的库区
		},

		/**
		 * 通道列表
		 */
		getWarehouse() {
			this.$http
				.request({
					url: "/api/checkTask/getWarehouse",
					method: "GET",
					params: {
						fcCode: this.mainSearch.fcCode || null,
					},
				})
				.then((res) => {
					if (res.status == 100) {
						this.warehouseList = res.data;
					} else {
						this.$message.error("错误");
					}
				});
		},

		/**
		 * 盘点——查询条件 todo
		 */
		insertStockCheckTaskByParam() {
			this.$confirm("是否确认将所有的查询结果进行盘点?", "提示", {
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$http
						.request({
							url: "/api/checkTask/insertStockCheckTaskByParam",
							method: "POST",
							showLoading: true,
							params: {
								fcCode: this.mainSearch.fcCode || null, //	工厂编号
								whCode: this.mainSearch.whCode || null, //	通道编号
								matCode: this.mainSearch.matCode || null, //	物料编号
								matName: this.mainSearch.matName || null, //	物料描述
								batchNo: this.mainSearch.batchNo || null, //	批次号
								wiStatus: this.mainSearch.wiStatus || null, //	库存状态
								boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
								beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
								endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
							},
						})
						.then((resp) => {
							if (resp.status == 100) {
								this.$message({
									message: "操作成功",
									type: "success",
								});
							} else {
								this.$message({
									message: resp.message,
									type: "error",
								});
							}
							this.getTableData();
						})
						.catch((error) => {
							this.$message({
								message: "操作失败:" + error.message,
								type: "warning",
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},

		/**
		 * 盘点——勾选
		 */
		insertStockCheckTaskByList() {
			if (this.checkList.length == 0) {
				this.$message({
					message: "请勾选库存！",
					type: "warning",
				});
				return;
			}
			this.$confirm("是否确认将已选择的库存进行盘点?", "提示", {
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$http
						.request({
							url: "/api/checkTask/insertStockCheckTaskByList",
							method: "POST",
							showLoading: true,
							data: this.checkList,
						})
						.then((resp) => {
							if (resp.status == 100) {
								this.$message({
									message: "操作成功",
									type: "success",
								});
							} else {
								this.$message({
									message: resp.message,
									type: "error",
								});
							}
							this.getTableData();
						})
						.catch((error) => {
							this.$message({
								message: "操作失败:" + error.message,
								type: "warning",
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		rePrintBarcodeNew(type) {
			if (this.selectAllPrintList.length == 0) {
				this.$message({
					message: "请勾选打印单！",
					type: "warning",
				});
				return;
			}
			let LODOP = this.printInit(this.selectAllPrintList);
			//打印
			type === 'print' ? LODOP.PRINT() : LODOP.PREVIEW()
		},
		//设置打印参数
		printInit(data) {
			if (false) {
			let printTime = moment().format("YYYY-MM-DD HH:mm:ss");
			let printList = data.map((item) => {
				// 更新qrCode生成规则 订单号+物料编号+箱数（默认1）+供应商+通道+总数量+供应商名称+生产日期+批次+状态+图纸版本号+供应商追溯号+箱号+锻造供应商+锻造炉号+钢材炉号+钢号+围板类型+发货日期+公差
				// 对照供应商箱标签打印页面处理
				console.log(item);
				var qrCode =
					item.orderCode +
					",;" +
					item.matCode +
					",;1,;" +
					item.verdorCode +
					",;" +
					item.whCode +
					",;" +
					item.matQuan +
					",;" +
					item.supplier +
					",;" +
					moment(item.matProduceTime).format("YYYY-MM-DD") +
					",;" +
					item.batchNo +
					",;" +
					item.status +
					",;" +
					item.drawCode +
					",;" +
					item.traceability +
					",;" +
					item.boxBarcode +
					",;" +
					item.forgeSupplierCode +
					",;" +
					item.forgeCode +
					",;" +
					item.heatNo +
					",;" +
					item.steelCode +
					",;" +
					item.coamingType +
					",;" +
					item.storeIssueTime +
					",;" +
					item.matSpecs;
				qrCode = qrCode.replaceAll("undefined", "");
				// P247244,YY010006,1,供应商,800,200,供应商名称,2025-03-18,批次,状态,图纸版本号,供应商追溯号,BX25031800184,锻造供应商,锻造炉号,钢材炉号,钢号,围版类型,,公差
				return {
					//订单号
					orderNo: item.orderCode,
					//物料编号
					wlType: item.matCode,
					// 供应商
					gyCode: item.verdorCode,
					//通道
					td: item.whCode,
					//数量
					num: item.matQuan,
					// 供应商名称
					gyName: item.supplier,
					//批次
					pc: item.batchNo,
					// 状态
					zt: item.status,
					// 图纸版本号
					tzVersion: item.drawCode,
					// 供应商追溯号
					gyTrace: item.traceability,
					// 箱号
					boxBarcode: item.boxBarcode,
					//锻造供应商
					dzGY: item.forgeSupplierCode,
					//锻造炉号
					dzNo: item.forgeCode,
					//钢材炉号
					gcLN: item.heatNo,
					//钢号
					gcNo: item.steelCode,
					// 围板类型
					wbType: item.coamingType,
					// 发货日期
					fhDate: moment(item.storeIssueTime).format("YYYYMMDD"),
					// 公差
					gc: item.matSpecs,
					//打印日期
					dyDate: printTime,
					//二维码
					qrCode: qrCode,
					// 物料名称
					wlName: item.matName,
				};
			});
			}
			console.log("打印信息:", data);
			let LODOP = getLodop();
			LODOP.PRINT_INIT("标签打印");
			data.forEach((item) => {
				//强制分页
				LODOP.NEWPAGE();
				//设置打印样式
				// this.setPrintSty(LODOP, item);
                const param = printParamsFormat(item)
				printBoxBarcode(param, LODOP)
			});
			return LODOP;
		},
		//设置打印格式
		setPrintSty(LODOP, param) {
			//设置纸张大小 以下样式按照原始大小为138*105绘制，后缩放
			LODOP.SET_PRINT_PAGESIZE(1, "100mm", "79mm", "");

			//设置标题行属性
			LODOP.ADD_PRINT_RECT("1mm", "1mm", "136mm", "8mm", 0, 1); //边框
			LODOP.ADD_PRINT_TEXTA("title", "2mm", "45mm", "70mm", "8mm", "STOCK LABEL SKF NK");
			LODOP.SET_PRINT_STYLEA("title", "FontSize", 18);
			LODOP.SET_PRINT_STYLEA("title", "Alignment", 2);
			LODOP.SET_PRINT_STYLEA("title", "Bold", 1);

			//供应商名称
			LODOP.ADD_PRINT_RECT("9mm", "1mm", "68mm", "17mm", 0, 1); //边框
			LODOP.ADD_PRINT_TEXTA("gyName", "11mm", "2mm", "68mm", "8mm", " From 供应商:");
			LODOP.ADD_PRINT_TEXTA("gyName", "17mm", "2mm", "68mm", "8mm", " " + param.gyCode);
			LODOP.SET_PRINT_STYLEA("gyName", "FontSize", 14);
			LODOP.SET_PRINT_STYLEA("gyName", "Alignment", 1);
			// 送货地点
			LODOP.ADD_PRINT_RECT("9mm", "69mm", "68mm", "17mm", 0, 1); //边框
			LODOP.ADD_PRINT_TEXTA("toAddress", "11mm", "70mm", "68mm", "8mm", " To 送货地点:(NKO)");
			LODOP.ADD_PRINT_TEXTA(
				"toAValue",
				"17mm",
				"70mm",
				"68mm",
				"8mm",
				" 北京南口斯凯孚铁路轴承有限公司"
			);
			LODOP.SET_PRINT_STYLEA("toAddress", "FontSize", 14);
			LODOP.SET_PRINT_STYLEA("toAddress", "Alignment", 1);

			//设置二维码 QRCode指定二维码格式
			LODOP.ADD_PRINT_RECT("26mm", "1mm", "45mm", "78mm", 0, 1); //边框
			LODOP.ADD_PRINT_BARCODE("38mm", "6mm", "44mm", "46mm", "QRCode", param.qrCode);
			// 标签打印时间
			LODOP.ADD_PRINT_TEXTA("bqdyDate", "83mm", "10mm", "40mm", "8mm", "标签打印时间");
			LODOP.ADD_PRINT_TEXTA("bqdyValue", "90mm", "8mm", "45mm", "8mm", param.dyDate);
			LODOP.SET_PRINT_STYLEA("bqdyDate", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("bqdyDate", "Alignment", 2);
			LODOP.SET_PRINT_STYLEA("bqdyValue", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("bqdyValue", "Alignment", 2);

			// 箱号+订单号+通道+物料型号+物料名称+每箱数量 top left width height
			LODOP.ADD_PRINT_RECT("26mm", "46mm", "91mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "29mm", "47mm", "14mm", "6mm", "箱号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "29mm", "61mm", "75mm", "6mm", param.boxBarcode);
			LODOP.ADD_PRINT_TEXTA("contentKey", "35mm", "47mm", "19mm", "6mm", "订单号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "35mm", "66mm", "70mm", "6mm", param.orderNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "41mm", "47mm", "14mm", "6mm", "通道:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "41mm", "61mm", "75mm", "6mm", param.td);
			LODOP.ADD_PRINT_TEXTA("contentKey", "47mm", "47mm", "24mm", "6mm", "物料编号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "47mm", "71mm", "65mm", "6mm", param.wlType);
			LODOP.ADD_PRINT_TEXTA("contentKey", "53mm", "47mm", "24mm", "6mm", "物料名称:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "53mm", "71mm", "75mm", "6mm", param.wlName);
			LODOP.ADD_PRINT_TEXTA("contentKey", "59mm", "47mm", "24mm", "6mm", "每箱数量:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "59mm", "71mm", "65mm", "6mm", param.num);

			// 公差+批次+发货日期+围板类型+钢号+钢材炉号
			LODOP.ADD_PRINT_RECT("65mm", "46mm", "42mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", "47mm", "13mm", "6mm", "公差:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", "60mm", "32mm", "6mm", param.gc);
			LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", "47mm", "13mm", "6mm", "批次:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", "60mm", "32mm", "6mm", param.pc);
			LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", "47mm", "22mm", "6mm", "发货日期:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", "67mm", "25mm", "6mm", param.fhDate);
			LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", "47mm", "22mm", "6mm", "围板类型:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", "69mm", "23mm", "6mm", param.wbType);
			LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", "47mm", "13mm", "6mm", "钢号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", "60mm", "32mm", "6mm", param.gcNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", "47mm", "22mm", "6mm", "钢材炉号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", "69mm", "23mm", "6mm", param.gcLN);

			LODOP.ADD_PRINT_RECT("65mm", "88mm", "49mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", "89mm", "22mm", "6mm", "锻造炉号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", "111mm", "27mm", "6mm", param.dzNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", "89mm", "26mm", "6mm", "锻造供应商:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", "115mm", "23mm", "6mm", param.dzGY);
			LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", "89mm", "26mm", "6mm", "供应商名称:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", "115mm", "23mm", "6mm", param.gyName);
			LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", "89mm", "31mm", "6mm", "供应商追溯号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", "120mm", "18mm", "6mm", param.gyTrace);
			LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", "89mm", "26mm", "6mm", "图纸版本号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", "115mm", "23mm", "6mm", param.tzVersion);
			LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", "89mm", "13mm", "6mm", "状态:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", "102mm", "36mm", "6mm", param.zt);

			// 项目名样式
			LODOP.SET_PRINT_STYLEA("contentKey", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("contentKey", "Alignment", 1);
			// 项目值样式
			LODOP.SET_PRINT_STYLEA("contentValue", "FontSize", 14);
			LODOP.SET_PRINT_STYLEA("contentValue", "Alignment", 1);
			LODOP.SET_PRINT_STYLEA("contentValue", "Bold", 1);

      		LODOP.SET_PRINT_STYLE('FontName', '黑体')
			// 缩放以适应纸张大小
			LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Page");

			return LODOP;
		},

		//标签打印
		rePrintBarcode() {
			if (this.selectAllPrintList.length == 0) {
				this.$message({
					message: "请勾选打印单！",
					type: "warning",
				});
				return;
			}
			//无码时添加打印限制
			if (this.lazyNext) {
				this.$message.error("请五秒后再打印！");
				return;
			} else {
				this.selectAllPrintList.forEach((item) => {
					var produceTime = moment(item.matCreateTime).format("YYYYMMDD");
					//T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
					// var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
					//     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
					//     "/" + produceTime + "/" + item.boxHeight + "/";

					//箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
					var qrCode =
						item.boxBarcode +
						"," +
						item.orderCode +
						"," +
						item.whCode +
						"," +
						item.matCode +
						"," +
						item.matQuan +
						"," +
						item.matSpecs +
						"," +
						item.batchNo +
						"," +
						produceTime +
						"," +
						item.boxHeight +
						",,,";

					if (item.matSpecs == undefined) {
						item.matSpecs = "";
					}

					var person = localStorage.getItem("user");
					if (person != undefined && person != "") {
						person = item.consignee;
					}

					var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
					var barcodeData = {
						boxBarcode: item.boxBarcode,
						prodCode: item.matCode,
						prodName: item.matName,
						batchNo: item.batchNo,
						count: item.matQuan,
						checkPerson: person,
						date: produceTime,
						poCode: item.orderCode,
						matSpecs: item.matSpecs,
						whCode: item.whCode,
						qrCode: qrCode,
						supply: item.verdorCode,
						printTime: printTime,
						isSta: false,
						printTwo: false,
						location: item.lcCode,
						boxHeight: item.boxHeight,
						heatBatchNo: item.heatNumber,
						luhao: item.heatNo,
						oldBoxbarcode: item.oldBoxBarcode,
						checkResult: item.checkResult,
						remark: item.lcCode,
					};
					this.$printer.printWMSBarcode(barcodeData);
				});

				this.lazyNext = setTimeout(() => {
					this.lazyNext = null;
				}, 5000);
			}
		},

		//表格导出
		downLoadFile() {
			this.downloadLoading = true;
			var mainSearchLcType = "";
			var whCode = "";
			this.chooseDictDataList.forEach((item) => {
				mainSearchLcType += item + ",";
			});
			this.whCodeList.forEach((item) => {
				whCode += item + ",";
			});
			if (this.selectAllPrintList.length != 0) {
				this.downLoad(this.selectAllPrintList);
				return;
			}
			var paramsObj = {
				fcCode: this.mainSearch.fcCode || null, // 工厂编号
				whCode: whCode || null, // 通道编号
				lcCode: this.mainSearch.lcCode || null,
				lcType: mainSearchLcType || null,
				matCode: this.mainSearch.matCode.join(',') || null, // 物料编号
				matName: this.mainSearch.matName || null, // 物料描述
				batchNo: this.mainSearch.batchNo || null, // 批次号
				wiStatus: this.mainSearch.wiStatus || null, // 库存状态
				boxBarcode: this.mainSearch.boxBarcode || null, // 箱号
				opCode: this.mainSearch.orderCode || null, //  订单编号
				matSpecs: this.mainSearch.matSpecs || null, //规值
				beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
				endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
				height: this.mainSearch.height || null,
				consignee: this.consignee || null,
				oldBoxBarcode: this.mainSearch.oldBoxBarcode || null,
				checkResult: this.mainSearch.checkResult || null,
				saleFlag: this.mainSearch.saleFlag,
				whType: this.mainSearch.whType,
				receiptResult: this.mainSearch.receiptResult || null,
				verdorCode: this.mainSearch.verdorCode,
				mtType: this.mainSearch.mtType.join(',') || null,
				SBN: this.mainSearch.SBN,
				waCode: this.mainSearch.waCode,
				pageNum: 1,
				pageSize: 999999,
			};

			this.$http
				.request({
					url: "/api/order/getStockList",
					method: "GET",
					params: paramsObj,
				})
				.then((resp) => {
					resp.status == 100
						? this.downLoad(resp.data.list || [])
						: this.$notify.error({
								message: "查询失败",
						  });
				});
		},
		dateFormat(row, column) {
			var date = row[column.property];
			if (date == undefined) {
				return "";
			}
			return moment(date).format("YYYY-MM-DD");
		},
		downLoad(list) {
			list.forEach(function(c) {
				if (c.wiStatus == "NORMAL") {
					c["wiStatus"] = "正常";
				}
				// else if (c.wiStatus == "FREEZE") {
				// 	c["wiStatus"] = "拣配中";
					// } else if (c.wiStatus == 'OVERTIME') {
					//     c['wiStatus'] = '过期'
					// } else if (c.wiStatus == 'DELETE') {
					//     c['wiStatus'] = '作废'
				// }
				else if (c.wiStatus == "AGFREEZE") {
					c["wiStatus"] = "冻结";
				} else {
					c["wiStatus"] = "";
				}

				if (c.checkResult == "10") {
					c["checkResult"] = "待检";
				} else if (c.checkResult == "20") {
					c["checkResult"] = "合格";
				} else if (c.checkResult == "30") {
					c["checkResult"] = "不合格";
				} else if (c.checkResult == "40") {
					c["checkResult"] = "退货";
				} else {
					c["checkResult"] = "";
				}

				if (c.saleFlag) {
					c["saleFlag"] = "寄售仓";
				} else {
					c["saleFlag"] = "非寄售仓";
				}
				if (c.receiptResult == "01") {
					c["receiptResult"] = "待接收";
				} else if (c.receiptResult == "10") {
					c["receiptResult"] = "确认接收";
				} else if (c.receiptResult == "20") {
					c["receiptResult"] = "拒绝接收";
				} else if (c.receiptResult == "30") {
					c["receiptResult"] = "退货";
				} else {
					c["receiptResult"] = "";
				}
				if (c.oldBoxBarcode == undefined || c.oldBoxBarcode == null) {
					c.oldBoxBarcode = c.boxBarcode;
				}

				c.matAvaliableQuan = (c.matQuan || 0) - (c.matDistrQuan || 0)
			});
			import("@/libs/Export2Excel").then((excel) => {
				const tHeader = [
					"订单编号",
					"物料编号",
					"物料描述",
					"规值",
					"可用数量",
					"物料总数量",
					"物料状态",
					"质检状态",
					"物料批次",
					"包装箱号",
					"库位",
					"库区",
					"仓库类型",
					"入库时间",
					"生产时间",
					"通道编号",
					"已分配数量",
					"通道状态",
					"供应商",
					"供应商名称",
					"收货人",
					"物料类型",
					"原箱号",
					"备注"
				];
				const filterVal = [
					"orderCode",
					"matCode",
					"matName",
					'matSpecs',
					"matAvaliableQuan", // todo
					"matQuan",
					"wiStatus",
					"checkResult",
					"batchNo",
					"boxBarcode",
					"lcCode",
					"waCode",
					"saleFlag", // todo
					"matCreateTime",
					"matProduceTime",
					"whCode",
					"matDistrQuan",
					"receiptResult", // todo
					"verdorCode",
					"svName",
					"consignee",
					"mtType",
					"oldBoxBarcode",
					"remark",
				];
				const data = this.formatJson(filterVal, list);
				excel.export_json_to_excel({
					header: tHeader,
					data,
					filename: "库存记录单",
				});
				this.logContent = "导出";
				this.logRemarks = "wh_inventory：导出库存记录";
				this.systemLog();
				this.downloadLoading = false;
			});
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) => filterVal.map((j) => v[j]));
		},

		//修改库存
		upWhInventory() {
			if (this.selectAllPrintList.length == 0) {
				this.$message({
					message: "请选择库存记录！",
					type: "warning",
				});
				return;
			}
			if (this.selectAllPrintList.length > 1) {
				this.$message({
					message: "只能选择单条库存记录！",
					type: "warning",
				});
				return;
			}
			this.upDataShow = true;
			this.upDataObj = this.deepCopy(this.selectAllPrintList[0]);
		},

		updateWhInventory() {
			if (this.submitForm("upDataObj")) {
				this.$http
					.request({
						url: "/api/inventory/updateInventoryData",
						method: "POST",
						showLoading: true,

						data: this.upDataObj,
					})
					.then((resp) => {
						if (resp.status == 100) {
							this.$notify({
								title: "成功",
								message: "编辑成功！",
								type: "success",
							});
							this.logRemarks =
								"WhInventory：编辑成功 原库位：" +
								this.upDataObj.lcCode +
								"箱号：" +
								this.upDataObj.boxBarcode +
								" 原数量：" +
								this.upDataObj.matQuan +
								JSON.stringify(this.upDataObj);
						} else {
							this.$notify.error({
								title: "失败",
								message: "编辑失败",
							});
							this.logRemarks = "WhInventory：编辑失败" + JSON.stringify(this.upDataObj);
						}
						this.upDataShow = false;
						this.saveSearch();
						this.systemLog();
					});
			}
		},
		//表单验证
		submitForm(formName) {
			let r = Boolean;
			this.$refs[formName].validate((valid) => {
				if (valid) {
					r = true;
				} else {
					r = false;
				}
			});
			return r;
		},

		/**
		 * 操作日志
		 */
		systemLog() {
			let objData = {
				logType: "库存记录",
				logContent: this.logRemarks || "",
				//logRemarks: this.logRemarks || "",
				logUser: localStorage.getItem("user") || "",
			};
			this.$http
				.request({
					url: "api/log/insert",
					method: "POST",
					showLoading: true,
					data: objData,
				})
				.then((resp) => {
					this.logContent = "";
					this.logRemarks = "";
					if (resp.status == 100) {
					}
				})
				.catch((error) => {});
		},
		closeExportModel() {
			this.importInShow = false;
			this.getTableData();
		},
		insertUploadFile() {
			this.uploaderData.fileList.forEach((ele) => {
				var formData = new FormData();
				formData.append("fileList", ele.file);
				this.$http
					.request({
						url: this.httpUrl + "/api/uploadFile/dosupload",
						method: "POST",
						headers: {
							"Content-Type": "multipart/form-data",
						},
						showLoading: true,
						data: formData,
					})
					.then((res) => {
						if (res.status === 100) {
							this.presentData.ufAddress = res.data;
							this.presentData.boxBarcode = this.scanData.boxBarcode;
							this.presentData.remark = this.scanData.remark;
							this.$http
								.request({
									url: this.httpUrl + "/api/uploadFile/insertUploadFile",
									method: "PUT",
									showLoading: true,
									data: this.presentData,
								})
								.then((res) => {
									if (res.status === 100) {
										this.uploaderData = {
											fileList: [],
										};
										this.scanData = {
											boxCode: "",
											boxBarcode: "",
											remark: "",
										};
										this.$notify({
											message: "上传成功!",
											type: "success",
										});
									} else if (res.status == 500) {
										this.$notify({
											message: "服务器异常!",
											type: "danger",
										});
									} else {
										this.$notify({
											message: res.message,
											type: "danger",
										});
									}
								});
						} else {
							this.$notify({
								message: res.message,
								type: "danger",
							});
						}
					});
			});
		},
		async getMaterialList() {
			try {
				const res = await this.$http
					.request({
						url: "/api/material/getMaterialAll",
						method: "GET",
						params: {
							pageNum: 1,
							pageSize: 999999,
						}
					})
				if (res.status == 100) {
					this.materialList = res.data.list
				} else {
					this.materialList = []
				}
			} catch (error) {
				this.materialList = []
			}
		},
		async getLcCodeList() {
			try {
				const res = await this.$http.request({
					url: "/api/location/getLocationAll",
					method: "GET",
					showLoading: true,
					params: {
						pageNum: 1,
						pageSize: 999999,
					},
				})
				if (res.status == 100) {
					this.lcCodeList = res.data.list
				} else {
					this.lcCodeList = []
				}
			} catch (error) {
				this.lcCodeList = []
			}
		},
		async getVerdorList() {
			try {
				const res = await this.$http.request({
					url: "/api/vendor/getVendorAll",
					method: "GET",
					showLoading: true,
					params: {
						pageNum: 1,
						pageSize: 999999,
					},
				})
				if (res.status == 100) {
					this.vendorList = res.data.list
				} else {
					this.vendorList = []
				}
			} catch (error) {
				this.vendorList = []
			}
		},
		async getMtTypeList() {
			try {
				const res = await this.$http.request({
					url: "/api/dictData/getDictData",
					method: "GET",
					showLoading: true,
					params: {
						ddCode: "MDTYPE",
					},
				})
				if (res.status == 100) {
					this.mtTypeList = res.data.list
				} else {
					this.mtTypeList = []
				}
			} catch (error) {
				this.mtTypeList = []
			}
		},
	},
};
</script>

<style scoped>
.div {
	width: 95%;
	height: 100%;
	/* border: 1px solid black; */
	/* margin-top: 107px; */
	margin-left: 30px;
	margin-bottom: 100px;
	text-align: center;
}

.div table th {
	width: 100px;
	height: 30px;
	border: 1px solid black;
	background: rgb(201, 197, 197);
	color: rgb(14, 13, 13);
}

.div table td {
	width: 100px;
	height: 30px;
	/* border: 1px solid black; */
	color: rgb(14, 13, 13);
}

.div1 {
	/* width: 300px; */
	height: 40px;
	/* border: 1px solid black; */
	text-align: left;
	color: rgb(14, 13, 13);
	font-weight: bold;
	margin-left: 50px;
}
</style>
